import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import CentralHeating from './central-heating';
import CentralHeatingDetail from './central-heating-detail';
import CentralHeatingUpdate from './central-heating-update';
import CentralHeatingDeleteDialog from './central-heating-delete-dialog';

const CentralHeatingRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<CentralHeating />} />
    <Route path="new" element={<CentralHeatingUpdate />} />
    <Route path=":id">
      <Route index element={<CentralHeatingDetail />} />
      <Route path="edit" element={<CentralHeatingUpdate />} />
      <Route path="delete" element={<CentralHeatingDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CentralHeatingRoutes;
